import { Component, Input, OnInit } from '@angular/core';
import { IWell } from '../models/wells.inteface';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-search-dmu',
  templateUrl: './search-dmu.component.html',
  styleUrls: ['./search-dmu.component.scss'],
})
export class SearchDmuComponent  implements OnInit {
  @Input() showMenu!: boolean;
  @Input() wellList: IWell[] = [];
  search!: string;
  constructor(public mapService: MapService) { }

  ngOnInit() {}
  

}
